import {allCsgoOptions} from "../api/api";

export const mixins = {
  data() {
    return {
      weaponCasesIndex:{},
      weaponCasesOptions:[],
      categoryOptions:[],
      stickerCapsuleOptions:[]
    };
  },
  computed: {},
  created() {
    allCsgoOptions().then(json => {
      for (let weaponCase of json.data.data.weaponCases) {
        this.weaponCasesIndex[weaponCase.optionValue] = weaponCase.optionKey
      }
      this.weaponCasesOptions = json.data.data.weaponCases || []
      this.categoryOptions = json.data.data.categoryOptions || []
      this.stickerCapsuleOptions = json.data.data.stickerCapsule || []
    })
  },
  mounted() {},
  methods: {},
};



// WEBPACK FOOTER //
// ./src/mixin/index.js